export default {
    setFeedback(state,payload){
        state.feedback = payload;
    },
    setFeedbackPages(state, payload){
        state.feedbackPages = payload;
    }
}